import { Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { ListenersRegistry } from '@skylab-shared/utils';
import { v4 as uuid } from 'uuid';
import { PanelService } from './panel.service';

@Component({
    selector: 'skl-panel-wrapper',
    templateUrl: './panel-wrapper.component.html',
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class PanelWrapperComponent extends ListenersRegistry(class { }) implements OnInit, OnDestroy {
    private readonly wrapperId = uuid();

    public constructor(
        private readonly element: ElementRef<HTMLElement>,
        private readonly panelService: PanelService) {
        super();
    }

    public ngOnInit(): void {
        this.registerListening(this.panelService.addWrapper(this.wrapperId));
        this.element.nativeElement.setAttribute('panel-wrapper-id', this.wrapperId);
    }

    public ngOnDestroy(): void {
        this.deregisterAllListeners();
    }
}
